import { render, staticRenderFns } from "./delegate_dialog.vue?vue&type=template&id=623d5c6d&scoped=true&"
import script from "./delegate_dialog.vue?vue&type=script&lang=js&"
export * from "./delegate_dialog.vue?vue&type=script&lang=js&"
import style0 from "./delegate_dialog.vue?vue&type=style&index=0&id=623d5c6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d5c6d",
  null
  
)

export default component.exports